// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a023c088","239":"16111b59","455":"0811bf50"}[chunkId] + ".chunk.js";
};